//
//
//
//
//
//

export default {
  name: 'gotoMini',
  components: {
  },
  data () {
    return {
       isWxReady: false,
      code:'HMG-M001-24080848',
    }
  },
  created(){
   
  },
  mounted(){
    this.initWxConfig();
  },
  methods:{
    loadWxSdk() {
      return new Promise((resolve, reject) => {
        if (window.wx) return resolve(window.wx)
        const script = document.createElement("script")
        script.src = "https://res.wx.qq.com/open/js/jweixin-1.6.0.js"
        script.onload = () => resolve(window.wx)
        script.onerror = reject
        document.head.appendChild(script)
      })
    },
    async initWxConfig() {
      try {
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
          url = url[0].split('?');
        }
        const wx = await this.loadWxSdk()
          this.$api.wxSign({url:url[0]}).then((res)=>{
            wx.config({
                // debug: res.data.debug, // 开启调试模式,
                debug: true, // 开启调试模式,
                appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature,// 必填，签名，见附录1
                jsApiList: res.data.jsApiList || ['navigateToMiniProgram'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            wx.ready(() => {
              console.log("✅ 微信SDK已就绪")
              this.isWxReady = true
            })
            wx.error((err) => {
              console.error("❌ 微信SDK配置失败", err)
              this.isWxReady = false
            })
          });
        } catch (err) {
          console.error("❌ 初始化微信SDK失败", err)
        }
    },
    // 跳转小程序
    openMiniProgram() {
      if (!this.isWxReady) {
        alert("请在微信中打开此页面")
        return
      }
      
      const wx = window.wx
        if (!wx.navigateToMiniProgram) {
        alert('当前微信版本过低或SDK未注入')
        console.log('wx对象', Object.keys(wx))
        return
      }
      wx.ready(()=> {
        wx.navigateToMiniProgram({
          appId: "wx3870add8734b5fb3", // 🔹 替换为你的小程序AppID
          path: "pages/box/box",
          extraData: { scene: 'code='+this.code }, // 可选：传递数据
          envVersion: "release", // "develop" 或 "trial"
          success: (res) => console.log("✅ 跳转成功", res),
          fail: (err) => {
            console.error("❌ 跳转失败", err)
            alert("跳转失败，请在微信中打开")
          },
        })
      })
    },
  },

}



// WEBPACK FOOTER //
// ./src/pages/gotoMini.vue